var map = {
	"./audio/ringtone.mp3": 419,
	"./images/anytime-anywhere.svg": 1556,
	"./images/app-store-badge.svg": 665,
	"./images/assessment.png": 258,
	"./images/assessment.svg": 1557,
	"./images/babylon_us_ios_app.png": 216,
	"./images/card-payment.jpg": 1558,
	"./images/check-bullet.svg": 1559,
	"./images/icon_gcal.png": 1547,
	"./images/icon_ical.png": 1548,
	"./images/icon_outlook.png": 1549,
	"./images/injection-instructions/global-checkin-norefill.mp4": 723,
	"./images/injection-instructions/wegovy-cap-pen.mp4": 720,
	"./images/injection-instructions/wegovy-check-clarity.mp4": 708,
	"./images/injection-instructions/wegovy-check-dose.mp4": 571,
	"./images/injection-instructions/wegovy-check-flow-for-drop.mp4": 714,
	"./images/injection-instructions/wegovy-check-flow.mp4": 713,
	"./images/injection-instructions/wegovy-choose-injection-site.mp4": 716,
	"./images/injection-instructions/wegovy-clean-the-injection-site.mp4": 717,
	"./images/injection-instructions/wegovy-drop-or-not.mp4": 715,
	"./images/injection-instructions/wegovy-inject-allsteps-waist.mp4": 718,
	"./images/injection-instructions/wegovy-inject-remove-needle.mp4": 719,
	"./images/injection-instructions/wegovy-innercap-remove.mp4": 712,
	"./images/injection-instructions/wegovy-needle-box-and-paper-off.mp4": 709,
	"./images/injection-instructions/wegovy-outercap-remove.mp4": 711,
	"./images/injection-instructions/wegovy-pencap-remove.mp4": 707,
	"./images/injection-instructions/wegovy-pencap-replace.mp4": 722,
	"./images/injection-instructions/wegovy-remove-needle.mp4": 721,
	"./images/injection-instructions/wegovy-twist-on-needle.mp4": 710,
	"./images/lifestyle-health.svg": 1560,
	"./images/logo/ask-a-and-e--square.png": 1561,
	"./images/logo/ask-a-and-e.png": 1562,
	"./images/logo/babylon--square.png": 1563,
	"./images/logo/babylon-brazil-einstein--square.png": 1564,
	"./images/logo/babylon-brazil-einstein.png": 1565,
	"./images/logo/babylon.png": 1566,
	"./images/logo/bupa.png": 1567,
	"./images/logo/columbus-direct.png": 1568,
	"./images/logo/eMed-heart.png": 691,
	"./images/logo/gp-at-hand.png": 1569,
	"./images/logo/nhs-rwt.png": 1570,
	"./images/logo/nhs-services.png": 1571,
	"./images/logo/nhs-uhb-ed.png": 1572,
	"./images/logo/nhs.png": 1573,
	"./images/logo/none.png": 1574,
	"./images/logo/united-healthcare.png": 1575,
	"./images/logo_square.png": 1545,
	"./images/map-pin-blank.svg": 1550,
	"./images/map-pin-generic.svg": 1551,
	"./images/map-pin-pharmacy.svg": 1546,
	"./images/nhs-logo.svg": 1552,
	"./images/ozempic-inject-allsteps-waist.mp4": 706,
	"./images/play-store-badge.svg": 666,
	"./images/waves.svg": 1576,
	"./images/weight-loss_clinician-call.jpg": 704,
	"./images/weight-loss_female-doctor.jpg": 699,
	"./images/weight-loss_get-your-medication.jpg": 700,
	"./images/weight-loss_gym.jpg": 698,
	"./images/weight-loss_hands.png": 318,
	"./images/weight-loss_lose-weight.jpg": 701,
	"./images/weight-loss_person-on-scales.jpg": 420,
	"./images/weight-loss_scale.png": 317,
	"./images/weight-loss_science.jpg": 1577,
	"./images/weight-loss_syringe.png": 316,
	"./images/weight-loss_video.png": 1578,
	"./images/weight-loss_wegovy.jpg": 319,
	"./images/welcome_screen.jpg": 695,
	"./info-icon.svg": 1579,
	"./logo_heart.png": 1580,
	"./logo_heart_small.png": 1581
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context */ 35).then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1267;
module.exports = webpackAsyncContext;